import toMoney from '~/common/masked/toMoney';
import { CellProps } from '~/ui/components';

export function cellToMoney<TData>(props: CellProps<TData>) {
  const value = props?.getValue<number | string>();
  return value ? toMoney(value) : '-';
}
